import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllCountryQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllCountry (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;